import type { TRuleWithTheme } from 'styles/theme';

export const modal: TRuleWithTheme = ({ theme }) => ({
    position: 'absolute',
    top: theme.metrics.height.header,
    right: theme.metrics.layoutPadding,
});
